export default "__VITE_ASSET__CJFZKXzh__";